<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import type {Link} from 'typings/portaro.be.types';
    import KpLinksMenu from 'shared/components/kp-links-menu/KpLinksMenu.svelte';

    export let availableExports: Link[];
    const localize = getLocalization();
</script>

<KpLinksMenu links="{availableExports}"
             dropdownButtonText="{localize(/* @kp-localization export.ExportVsechVyhledanych */ 'export.ExportVsechVyhledanych')}"
             showIfEmpty="{false}"
             buttonSize="xs"
             additionalClasses="search-export"/>